import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexGrid,
  ApexStroke,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis
} from "ng-apexcharts";
// import * as moment from 'moment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import {
  CountryISO,
  SearchCountryField
} from "ngx-intl-tel-input";
import { tap } from 'rxjs/operators';
// import { TranslatePipe } from 'src/app/core/pipes/translate.pipe';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { locationBroadcastService } from 'src/app/core/services/loaction-broadcast.service';
import { LocationsService } from 'src/app/core/services/locations/locations.service';
import { ApiService } from 'src/app/services/api';
import { TimezoneService } from 'src/app/services/timezone';
import { AppState } from 'src/app/store/app.state';
import { setLoadingSpinner } from 'src/app/store/sharedstate/shared.actions';
import { BreadcrumbService } from './../../services/breadcrumb';
import { DashboardReportComponent } from './dashboard-report/dashboard-report.component';
import { LiveCardComponent } from './live-card/live-card.component';
import { NetSaleComponent } from './net-sale/net-sale.component';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  title: ApexTitleSubtitle;
};
export type ChartOptions2 = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  title: ApexTitleSubtitle;
};


@Component({
  selector: 'app-starter',
  templateUrl: './starter.component.html',
  styleUrls: ['./starter.component.scss'],
  // providers: [TranslatePipe],
})

/**
 * Utility starter component
 */
export class StarterComponent implements OnInit, AfterViewInit {
  @ViewChild(NetSaleComponent) childRefNetSale: NetSaleComponent;
  @ViewChild(LiveCardComponent) childRefLiveCard: LiveCardComponent;
  @ViewChild(DashboardReportComponent) childRefReports: DashboardReportComponent;

  @Input() supportDiv: Number =1;
  per:any = true
  // bread crumb items
  // breadCrumbItems: Array<{}>;
  public chartOptions: Partial<ChartOptions>;
  public chartOptions2: Partial<ChartOptions2>;
  selected: any;
  alwaysShowCalendars: boolean;
  token : any;
  settings = false;
  GLOBALURL = this.ApiService.getBaseURL();
  params = new HttpParams();
  activeIds: string[] = [];
  showExtraRows = {};
  storeId = this.cookieService.get("storeId");
  merchantId = this.cookieService.get("merchantId");
  responseData: any;
  ranges: any = {
    'Today': [this.timezoneService.get()(), this.timezoneService.get()()],
    'Yesterday': [this.timezoneService.get()().subtract(1, 'days'), this.timezoneService.get()().subtract(1, 'days')],
    'Last 7 Days': [this.timezoneService.get()().subtract(6, 'days'), this.timezoneService.get()()],
    'Last 30 Days': [this.timezoneService.get()().subtract(29, 'days'), this.timezoneService.get()()],
    'This Month': [this.timezoneService.get()().startOf('month'), this.timezoneService.get()().endOf('month')],
    'Last Month': [this.timezoneService.get()().subtract(1, 'month').startOf('month'), this.timezoneService.get()().subtract(1, 'month').endOf('month')]
  }
  invalidDates: moment.Moment[] = [this.timezoneService.get()().add(2, 'days'), this.timezoneService.get()().add(3, 'days'), this.timezoneService.get()().add(5, 'days')];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some(d => d.isSame(m, 'day'))
  }
  openedAccordions = ['restarunt', 'online', 'task'];
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  breadcrumbItems= [
    {
      label: 'Home',
      active: true,
      url: "/home",
    },
  ];

  showrestaurant_information: any;
  paymentIdPrefix: string;
  transactionIdPrefix: string;
  restaurantWebsite: string;
  merchantEmailAccount: string;
  merchantZipCode: string;
  merchantState: string;
  merchantCity: string;
  merchantAddress1: string;
  merchantAddress2: string;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] ;
  form: FormGroup;
  serviceAreaForm: FormGroup;

  merchantMobile: any;
  detectChanges: boolean;
  httpOptions2: { headers: HttpHeaders; params: HttpParams; };
  headerToken: string | { [name: string]: string | string[]; };
  addressErrors: { merchantAddress1: string; merchantAddress2: string; merchantCity: string; merchantState: string; merchantZipCode: string; };
  hasAddressErrors: boolean;
  transactionMsg: string;
  paymentMsg: string;
  submitted: boolean = false;
  submittedFloor: boolean = false;
  zoneNumber: any;
  zoneName: any;
  areas: any;
  loader: boolean;
  zones: any = [];
  route: string;
  showAlert: boolean = false;
  alertMsg: any;
  redirectionLink: any;
  storeAlertId: any;
  buttonText: string[];
  action: any;
  constructor(private store: Store<AppState>,
    private locService: locationBroadcastService,
    private BreadcrumbService: BreadcrumbService,
    private timezoneService: TimezoneService,
    private cookieService: CookieService,
    private ApiService: ApiService,
    private http: HttpClient,
    private locationService: LocationsService,
    private fb: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    private toastr: AlertService,
    // private translatePipe: TranslatePipe
  ) {
    this.alwaysShowCalendars = true;
    this.token = this.cookieService.get("token");
    this.chartOptions = {
      series: [
        {
          name: "This Month",
          data: [31, 40, 28, 51, 42, 109, 100],
          color: "#000"
        },
        {
          name: "Last Month",
          data: [11, 32, 45, 32, 34, 52, 41],
          color: "#CCCCCC",
        }
      ],

      chart: {
        height: 350,
        type: "line"
      },

      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth",
        width: 3
      },
      xaxis: {
        type: "datetime",
        categories: [
          "2018-09-19T00:00:00.000Z",
          "2018-09-19T01:30:00.000Z",
          "2018-09-19T02:30:00.000Z",
          "2018-09-19T03:30:00.000Z",
          "2018-09-19T04:30:00.000Z",
          "2018-09-19T05:30:00.000Z",
          "2018-09-19T06:30:00.000Z"
        ]
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm"
        }
      }
    },


      this.chartOptions2 = {
        series: [
          {
            name: "This Month",
            data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
            color: "#000"
          },
          {
            name: "Last Month",
            data: [20, 31, 34, 11, 79, 22, 39, 51, 148],
            color: "#888888"
          }
        ],
        chart: {
          height: 200,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        // title: {
        //   text: "Gross Sales",
        //   align: "left"
        // },
        grid: {
          row: {
            colors: ["#0000", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep"
          ]
        }

      };
  }
  public generateData(baseval, count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
      var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

      series.push([x, y, z]);
      baseval += 86400000;
      i++;
    }
    return series;
  }

  ngOnInit() {
    const userCountry = this.locationService.getUserCountry();
    this.preferredCountries = userCountry === CountryISO.UnitedKingdom
      ? [CountryISO.UnitedKingdom]
      : [userCountry, CountryISO.UnitedKingdom];
    // spinner off when redirect to home
    this.store.dispatch(setLoadingSpinner({ status: false }));
    // this.getStoredata();
    this.initializeForm();
    this.getAlert();
    this.initializeServiceAreaForm();
    this.headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
    this.httpOptions2 = {
      headers: new HttpHeaders(this.headerToken),
      params: this.params,
    };

    // Access first element since there is only one element in the breadcrumb


    // this.locService.currentApprovalStageMessage.subscribe(storeId => {
    //   if(storeId) {
    //     // this.changeStore(storeId)
    //     this.childRefNetSale.changeStore(storeId)
    //     this.childRefLiveCard.changeStore(storeId)
    //     this.childRefReports.changeStore(storeId)
    //   }
    // });
    // this.breadCrumbItems = [{ label: 'Utility' }, { label: 'Starter Page', active: true }];
    this.dropdownList = [
      { item_id: 1, item_text: 'Gross Sales' },
      { item_id: 2, item_text: 'Net Sales' },
      { item_id: 3, item_text: 'Total Customers' },
      { item_id: 4, item_text: 'Total Covers' },
      { item_id: 5, item_text: 'Total Orders' },
      { item_id: 6, item_text: 'Total Employees' },
      { item_id: 7, item_text: 'Total Taxes' },
      { item_id: 8, item_text: 'Total Tips' },
      { item_id: 8, item_text: 'Total Returning Customers' }
    ];
    this.selectedItems = [
      // { item_id: 3, item_text: 'Pune' },
      // { item_id: 4, item_text: 'Navsari' }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: 'ShowFilter'
    };
    // this.dropdownSettings:IDropdownSettings = {
    //   singleSelection: false,
    //   idField: 'item_id',
    //   textField: 'item_text',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true
    // };



  }
  ngAfterViewInit() {
    // this.translatePipe.transform(this.breadcrumbItems[0].label)
    //   .subscribe((res: string) => {
    //     console.log("TRANSLATINGGGG")
    //     this.breadcrumbItems[0].label = res;
    //     this.BreadcrumbService.setValue(this.breadcrumbItems);
    //   },
    //   (error) => {
    //     console.error("Error in translating", error);
    //   });
  }
  initializeForm() {
    this.form = this.fb.group({
      paymentIdPrefix: ['', Validators.required],
      transactionIdPrefix: ['', Validators.required ],
      restaurantWebsite: ['', [Validators.required,]],
      merchantEmailAccount: ['', [Validators.required, Validators.email]],
      merchantMobile: ['', Validators.required],
      merchantAddress1: ['', Validators.required],
      merchantAddress2: ['',],
      merchantCity: ['', Validators.required],
      merchantState: ['', Validators.required],
      merchantZipCode: ['', Validators.required]
    });
  }
  initializeServiceAreaForm() {
    this.serviceAreaForm = this.fb.group({
      zoneName: ['', Validators.required],
      zoneNumber: ['', Validators.required]
    });
  }
  createZoneFunction() {
      var params = {
        zoneName: this.zoneName.trim(),
        h: 0,
        w: 0,
        x: 0,
        y: 0,
        zoneNumber: this.zoneNumber,
        areas: [],
        storeId: this.storeId
      };
      this.loader = true;
      var httpOptions2 = { headers: new HttpHeaders(this.headerToken).set('Cache-Control', 'no-cache') };
      return this.http.post(this.GLOBALURL + "/zone", params, httpOptions2).subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
            this.loader = false;
          } else {
            this.detectChanges = true;
            this.loader = false;
            this.toastr.success(response.message);
            this.zones.push(response.response);
            // this.closeModal()

          }
        },
        error => {
          this.loader = false;
          this.toastr.error(error.error.message);
        }
      );
  }
  getStoredata() {

    // this.params = this.params.set("storeId", "66448befc879dd5bbc7bfe17");
    // this.params = this.params.set("merchantId", "66448befc879dd5bbc7bfe15");
    this.params = this.params.set("storeId", this.storeId)
    this.params = this.params.set("merchantId", this.merchantId)

    return this.http
    .get(this.GLOBALURL + "/storeSetupProcess", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
      params: this.params
    })
    .subscribe((response: any) => {
      if (!response.error) {
        this.responseData = response.response;
        console.log("response", this.responseData);
      }
    },
    (error) => {
      console.error("Failed to fetch setup process:", error);
    });
 }
 getProcessDesc(processName) {
  const descriptions = {
    "Account Setup": "Get your account ready with this essential setup process.",
    "Restaurant Information": "Enter key details about your restaurant for a personalized setup.",
    "Schedule  Information": "Easily configure your schedule settings with this step-by-step guide.",
    "Service Area Setup": "Outline the areas your restaurant services with detailed setup instructions.",
    "Store Setup": "Set up your store basics seamlessly with this comprehensive guide.",
    "Store Address Information": "Provide the address information your store needs to operate.",
    "TimeZone": "Set your store's time zone for accurate scheduling and operations.",
    "Daily Operational Hours": "Define and customize the daily operational hours of your store.",
    "Workforce Setup": "Set up and manage your workforce with this in-depth guide.",
    "Add Employee": "Easily onboard new employees to your team.",
    "Job Type & Pay Information": "Configure job types and pay details for accurate workforce management.",
    "Payroll Timing Setup": "Set up payroll timing to ensure timely payment for your employees.",
    "Menu Setup": "Create and manage your restaurant's menu with ease.",
    "Menu": "Add or update your menu items effortlessly.",
    "Category": "Organize your menu by setting up categories.",
    "Products": "Manage your restaurant's product offerings effectively.",
    "Modifier Groups": "Create groups of modifiers to customize order options.",
    "Add-Ons": "Add extra options to complement your menu items.",
    "Ingrediants": "Track and manage the ingredients used in your dishes.",
    "Courses": "Structure your menu with courses for a complete dining experience.",
    "Service Charge": "Set up service charges applicable to your orders.",
    "Tax": "Configure tax settings to comply with regulations.",
    "Initial Integration Setup": "Integrate with external services to enhance your operations.",
    "Card Connect": "Set up Card Connect for seamless payment processing.",
    "Poynt": "Integrate Poynt for advanced payment solutions.",
    "Stripe": "Configure Stripe to manage your payment transactions effectively.",
    "Deposit Settings": "Define settings for deposits efficiently.",
    "Hardware Setup": "Get your hardware devices up and running with this guide.",
    "Full Service Device Setup": "Set up full-service devices to streamline operations.",
    "Card Connect Device Setup": "Configure Card Connect devices for payment processing.",
    "Poynt Device Setup": "Set up Poynt devices to enable smooth transactions.",
    "Printer Setup": "Ensure your printers are correctly set up for efficient operations.",
    "KDS Setup": "Set up the Kitchen Display System to optimize order management.",
    "CFD Setup": "Configure Customer Facing Display to enhance customer experience.",
    "Online Order Setup": "Enable and manage online ordering for your restaurant.",
    "Online Website Setup": "Configure your online presence with this setup.",
    "Storefront Settings": "Customize your storefront settings for optimal functionality.",
    "Delivery Process Setup": "Organize your delivery process for smooth operations.",
    "Payment Setup": "Set up and manage payment options with ease.",
    "QR Order Setup": "Enable QR code ordering for a contactless experience."
  };

  return descriptions[processName] || "Description is not available.";
}

  updateStoreData(StoreDataPayload) {
    return this.http
      .put(this.GLOBALURL + "/storeSetupProcess", StoreDataPayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      });
  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  handleAccordion(menu) {
    const index = this.openedAccordions.indexOf(menu);
    if (index !== -1) {
      this.openedAccordions.splice(index, 1)
    } else {
      this.openedAccordions.push(menu);
    }
  }
  getHttpHeaders() {
    const headerContent = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    return new HttpHeaders(headerContent);
  }
  deleteRow(e , data) {
    let payload = {
      ...data,
      merchantId : this.merchantId,
      storeId: this.storeId,
      // remindLater:1,
      // merchantId : "66448befc879dd5bbc7bfe15",
      // storeId: "66448befc879dd5bbc7bfe17",
      // fromWeb:1
    };
    this.updateStoreData(payload).subscribe(
      (response) => {
        // e.target.closest('.rest-setup-list-item').style.display = 'none';
        const setupListItem = e.target.closest('.rest-setup-list-item-new');
        setupListItem && (setupListItem.style.display = "none");
        this.getStoredata();
      },
      (error) => {
        console.error(error);
      }
    );
  }

  changeStore(event: any) {

  }
  handlesettings() {
    this.settings = !this.settings
  }
  toggleAccordion(processName: string) {
    const index = this.activeIds.indexOf(processName);
    if (index === -1) {
      this.activeIds.push(processName);
    } else {
      this.activeIds.splice(index, 1);
    }
  }
  toggleExtraRows(task) {
    console.log(task, task.identifier,"test");
    this.showExtraRows[task.processName] = !this.showExtraRows[task.processName];
    if (task.identifier === 'schedule_information') {
        this.router.navigate(['/restaurant/schedule/new']);
      }
    if (task.identifier === 'store_address_information') {
      this.router.navigate(['/business-settings/location/new']);
    }
    if (task.identifier === 'TimeZone') {
      this.router.navigate(['/business-settings/location/new']);
    }
    if (task.identifier === 'daily_operational_hours') {
      this.router.navigate([`/business-settings/location/update/${this.storeId}`]);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 3000);
    }
    if (task.identifier === 'add_employee') {
      this.router.navigate(['/employees/add-employee']);
    }
    if (task.identifier === 'job_type_&_pay_information') {
      this.router.navigate(['/employees/add-employee']);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 3000);
    }
    if (task.identifier === 'payroll_timing_setup') {
      // this.router.navigate(['/restaurant/service-area/new']);
    }
    //reserch
    if (task.identifier === 'menu') {
      this.router.navigate(['/menumanagement/menus']);
    }
    if (task.identifier === 'category') {
      this.router.navigate(['/menumanagement/categories/new']);
    }
    if (task.identifier === 'products') {
      this.router.navigate(['/menumanagement/products/new']);
    }
    if (task.identifier === 'modifier_groups') {
      this.router.navigate(['/menumanagement/modifiers/new']);
    }
    //reserch
    if (task.identifier === 'add_ons') {
      this.router.navigate(['/menumanagement/addons/new']);
    }
    if (task.identifier === 'ingrediants') {
      this.router.navigate(['/menumanagement/ingredients/new']);
    }
    if (task.identifier === 'courses') {
      this.router.navigate(['/menumanagement/courses/new']);
    }
    if (task.identifier === 'service_charge') {
      this.router.navigate(['/restaurant/service-charge/new']);
    }
    if (task.identifier === 'tax') {
      this.router.navigate(['/restaurant/taxes/new']);
    }
    if (task.identifier === 'card_connect') {
      this.router.navigate(['/integration-marketplace/detailspage/CARDCONNECT']);
    }
    if (task.identifier === 'poynt') {
      this.router.navigate(['/integration-marketplace/detailspage/POYNT']);
    }
    if (task.identifier === 'stripe') {
      this.router.navigate(['/integration-marketplace/detailspage/STRIPE']);
    }
    if (task.identifier === 'deposit_settings') {
      this.router.navigate(['/menumanagement/discounts/new']);
    }
    // reserch
    if (task.identifier === 'full_service_device_setup') {
      this.router.navigate(['/hardware/point-of-sale']);
    }
    // reserch
    if (task.identifier === 'card_connect_device_setup') {
      this.router.navigate(['/menumanagement/discounts/new']);
    }
    // reserch
    if (task.identifier === 'poynt_device_setup') {
      this.router.navigate(['/menumanagement/discounts/new']);
    }
    // reserch
    if (task.identifier === 'printer_setup') {
      this.router.navigate(['/hardware/printer']);
    }
    if (task.identifier === 'kds_setup') {
      this.router.navigate(['/hardware/kitchen-display-system']);
    }
    if (task.identifier === 'cfd_setup') {
      this.router.navigate(['/hardware/customer-facing-display/step1']);
    }
    if (task.identifier === 'online_website_setup') {
      // this.router.navigate(['/menumanagement/discounts/new']);
    }
    //reserch
    if (task.identifier === 'storefront_settings') {
      this.router.navigate(['/onlinestore/store-front-settings']);
    }
    if (task.identifier === 'delivery_process_setup') {
      this.router.navigate(['/onlinestore/delivery']);
    }
    if (task.identifier === 'payment_setup') {
      this.router.navigate(['/onlinestore/payment']);
    }
    if (task.identifier === 'qr_rder_setup') {
      this.router.navigate(['/onlinestore/qr-code']);
    }
  }
  checkFieldshow(task) {
    if (task.identifier === 'restaurant_information') {
      this.showrestaurant_information = true;
    }
    else {
      this.showrestaurant_information = false;
    }
  }
  onSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      console.log(this.form.value);
      this.updateInformation(this.form.value);
      this.updateSetting(this.form.value);
    } else {
      console.log('Form is not valid');
      for (const field in this.form.controls) {
        if (!this.form.controls[field].valid) {
          console.log('Invalid field:', field);
        }
      }
    }
  }

  onSubmitZone() {
    this.submittedFloor = true;
    if (this.serviceAreaForm.valid) {
      console.log(this.serviceAreaForm.value);
      this.createZoneFunction();
    } else {
      console.log('Form is not valid');
      for (const field in this.serviceAreaForm.controls) {
        if (!this.serviceAreaForm.controls[field].valid) {
          console.log('Invalid field:', field);
        }
      }
    }
  }

  validateAddress() {
    this.addressErrors = {
      merchantAddress1: this.merchantAddress1?.trim() === "" ? "Address Line 1 is required" : "",
      merchantAddress2: this.merchantAddress2?.trim() === "" ? "Address Line 2 is required" : "",
      merchantCity: this.merchantCity?.trim() === "" ? "City is required" : "",
      merchantState: this.merchantState?.trim() === "" ? "State is required" : "",
      merchantZipCode: this.merchantZipCode?.trim() === "" ? "Postal Code is required" : ""
    };

    this.hasAddressErrors = Object.values(this.addressErrors).some((value) => value !== "");
  }

  updateInformation(data) {

    this.validateAddress();
    var typeOf = typeof this.form.get('merchantMobile').value;

    if (
      this.form.valid
    ) {
      var params = {
        merchantId: this.merchantId,
        // merchantName: this.merchantName.trim(),
        merchantWebsite: data?.restaurantWebsite.trim(),
        merchantEmail: data?.merchantEmailAccount.trim(),
        merchantPhoneCode: this.form.get('merchantMobile').value?.dialCode,
        merchantMobile:
          typeOf === "object"
            ? this.form.get('merchantMobile').value?.e164Number
            : data.merchantMobile?.e164Number,
        // merchantPhoneCode: data.merchantMobile?.dialCode,
        // merchantMobile: data.merchantMobile?.number,
        merchantAddress1: data?.merchantAddress1?.trim() == undefined ? "" : data?.merchantAddress1.trim(),
        merchantAddress2: data?.merchantAddress2?.trim() == undefined ? "" : data?.merchantAddress2.trim(),
        merchantCity: data?.merchantCity?.trim() == undefined ? "" : data?.merchantCity.trim(),
        merchantState: data?.merchantState?.trim() == undefined ? "" : data?.merchantState.trim(),
        merchantZipcode: data?.merchantZipCode?.trim() == undefined ? "" : data?.merchantZipCode.trim(),
        merchantCountry: data?.merchantMobile?.countryCode?.trim() == undefined ? "" : data?.merchantMobile.countryCode.trim(),

      };
      console.log("Update entered")
      this.http
        .put(this.GLOBALURL + "/merchant", params, this.httpOptions2)
        .subscribe(
          (response: any) => {
            console.log("done update", response);
            if (response.success == 0) {
              this.alertService.error(response.message, { autoClose: true });
            } else {
              this.detectChanges = true;
            }
          },
          (error) => {
            this.detectChanges = true;
            const message = this.ApiService.errorMessage(error)
            this.alertService.error(message, { autoClose: false });
          }
        );
      this.locationService
        .updateStore({
          storeId: this.storeId,
          // storeName: this.merchantName,
          // storeWebpage: this.merchantWebsite,
          storeAddress1: this.merchantAddress1,
          storeAddress2: this.merchantAddress2,
          storeCity: this.merchantCity,
          storeState: this.merchantState,
          storeZipcode: this.merchantZipCode,
          // storeCountry: this.merchantCountry,
          storeEmail: this.merchantEmailAccount,
          storePhone: this.merchantMobile,
        })
        .subscribe((response: any) => {
          if (response?.success === 0) {
            this.alertService.error(response?.message);
          } else {
            this.alertService.success(response?.message);
          }
        }
        );
    }
  }

  updateSetting(type) {
    if (this.storeId === "*" || this.storeId === undefined) {
      this.alertService.error("Please select a location first.");
      return;
    }
    this.validateAddress();

    if (
      this.form.invalid
    ) {
      return;
    }

    var payload = {
      settings: [],
      storeId: this.storeId,
    };

    if ('transactionIdPrefix' in type) {
      payload.settings.push({
        settingName: "TransactionPrefix",
        settingValue: String(type.transactionIdPrefix),
      });
    }

    if ('paymentIdPrefix' in type) {
      payload.settings.push({
        settingName: "PaymentPrefix",
        settingValue: String(type.paymentIdPrefix),
      });
    }
    console.log("payload============", payload);

    const headers = this.getHttpHeaders();
    this.http
      .put(this.GLOBALURL + "/settings", payload, { headers })
      .pipe(
        tap((response: any) => {
          if (response.success === 0) {
            this.alertService.error(response.message);
          } else {
            this.alertService.success(response.message);
          }
        })
      )
      .subscribe();
  }



  isOpen = false;

  toggleAccordionmain() {
    this.isOpen = !this.isOpen;
  }

  employeelist(){
    this.router.navigate(['/employees/employeelist']);
  }

  referral(){
    this.router.navigate(['/refer-earn']);
  }

  navigateToAnotherPage(){
   
  }

  employeeShift(){
    this.router.navigate(['/employees/shift']);
  }

  getAlert(){
    console.log("alert open")
    this.params = this.params.set("storeId", this.storeId)
    this.params = this.params.set("merchantId", this.merchantId)

    return this.http
    .get(this.GLOBALURL + "/store/alert/latest", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
      params: this.params
      
    })
    .subscribe((response: any) => {
      if (!response.error) {
        if((Object.keys(response.response).length) > 0){
          this.showAlert = true;
        }
        this.alertMsg = response.response.message;
        this.buttonText = response.response.buttons;
        this.action = response.response.action;
        this.redirectionLink = response.response.redirection;
        this.storeAlertId = response.response.storeAlertId;
        console.log("response123456", response);
        // this.responseData = response.response;
        // console.log("response", this.responseData);
      }
    },
    (error) => {
      this.showAlert = false;
      console.error("Failed to fetch alert status", error);
    });
  }
  alertClose (buttonText: string){
    console.log("alert close", buttonText)
    if (buttonText === 'Cancel') {
      this.showAlert = false;
    } else {
      this.showAlert = false;
      this.router.navigate([this.redirectionLink]); 
    }
    var params = {
      "storeAlertId":this.storeAlertId,
      "isClosed":true,
      "action":this.action ? this.action : buttonText
     }
    this.http
      .put(this.GLOBALURL + "/store/alert/status", params, this.httpOptions2)
      .subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
          } else {
          this.showAlert = false;
          // this.router.navigate([this.redirectionLink]); 
          this.toastr.success(response.message);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          // this.alertService.error(message);
          this.toastr.error(message);
        }
      );
  }
}
